<template>
  <div class="school-data-wrap" :class="{'school-data-wrap-other':artSchoolCondition.condition===2}">
    <div v-if="!istype" :class="{'school-out-div':artSchoolCondition.condition===2}">
      <div
        class="school-info"
        :class="{'school-info-other':artSchoolCondition.condition===2}"
        v-for="(item, index) in schoolData.data.records"
        :key="index"
      >
        <div class="info-logo">
          <router-link
            tag="a"
            target="_blank"
            :to="{
              path: '/main/schoolDetail/' + $route.name,
              query: { item: item.gb, zyz: item.zyz,pc:item.pc }
            }"
          >
            <img :src="item.logo" alt="院校logo" width="100%" height="100%" />
          </router-link>
        </div>
        <div class="info-introduce" :class="'info-introduce-other'">
          <div class="school-name">
            <router-link
              tag="a"
              target="_blank"
              :to="{
                path: '/main/schoolDetail/' + $route.name,
                query: { item: item.gb, zyz: item.zyz,pc:item.pc }
              }"
            >
              <h3>{{ item.yxmc }} <span v-if="$route.path === '/schoolRecommend'">[{{ item.zyz }}]专业组</span> </h3>
            </router-link>
            <div class="school-lqgl" v-if="$route.path === '/schoolRecommend'">
              (录取率:{{ item.lqgl }}%)
            </div>
          </div>
          <div class="school-category">
            <div class="category-wrap">
              <div class="category-item top-positon">
                往年批次:
                <span>{{ item.pc === ''?'-': item.pc===0?"本科提前批":item.pc===7?"高职专科批":""}}</span>
              </div>
              <div class="category-item">
                院校属性:
                <span v-if="item.sf985 !== '0'">985&nbsp;</span>
                <span v-if="item.sf211 !== '0'">211&nbsp;</span>
                <span v-else>普通高校</span>
              </div>
              <div class="category-item">所在地区:{{ item.yxdq }}</div>
              <!-- <div class="category-item">
                <button
                  type="button"
                  class="deleteSchool"
                  @click="deleteSchool(item)"
                  v-if="item.collect"
                >
                  取消收藏
                </button>
                <button
                  type="button"
                  class="addSchool"
                  @click="addSchool2(item)"
                  v-else
                >
                  加入收藏
                </button>
              </div> -->
            </div>
            <div class="info-data-wrap" v-if="artSchoolCondition.condition!==2">
              <table class="info-data">
                <tr v-if="item.examples&&item.examples.length">
                  <th rowspan="2">年度</th>
                  <!-- <th rowspan="2">专业成绩换算系数</th>
                  <th rowspan="2">文化成绩换算系数</th> -->
                  <th colspan="3">综合成绩</th>
                  <el-tooltip placement="top">
                    <div slot="content">
                      我的综合成绩就是分别把当年的文化成绩和专业成绩折算成<br />表中年度对应成绩后，再按占比进行计算
                    </div>
                    <th rowspan="2">我的综合成绩</th>
                  </el-tooltip>
                  <th colspan="2">招生计划</th>
                  <th rowspan="2">操作</th>
                </tr>
                <tr v-if="item.examples&&item.examples.length">
                  <th>最低分</th>
                  <th>平均分</th>
                  <th>最高分</th>
                  <th>当年</th>
                  <th>今年</th>
                </tr>
                <tr v-for="(innerItem, index) in item.examples" :key="index">
                  <td>{{ innerItem.year }}</td>
                  <!-- <td>
                    {{
                      innerItem.professionalProportion == 0
                        ? "-"
                        : innerItem.professionalProportion
                    }}
                  </td>
                  <td>
                    {{
                      innerItem.culturalProportion == 0
                        ? "-"
                        : innerItem.culturalProportion
                    }}
                  </td> -->
                  <td>
                    {{
                      innerItem.lowestScore == 0 ? "-" : innerItem.lowestScore
                    }}
                  </td>
                  <td>
                    {{
                      innerItem.averageScore == null
                        ? "-"
                        : innerItem.averageScore
                    }}
                  </td>
                  <td>
                    {{
                      innerItem.highestScore == null
                        ? "-"
                        : innerItem.highestScore
                    }}
                  </td>
                  <td v-if="index===0" rowspan="3">
                    {{ (innerItem.myScore == null || innerItem.myScore == 0) ? "-" : innerItem.myScore }}
                  </td>
                  <td>
                    {{
                      innerItem.currentPlan == 0 ? "-" : innerItem.currentPlan
                    }}
                  </td>
                  <td v-if="index === 0" rowspan="3">
                    {{ innerItem.thisPlan == null ? "-" : innerItem.thisPlan }}
                  </td>
                  <td v-if="index==0" rowspan="3">
                    <el-button :disabled="item.isCanDisabled"
                    type="primary" size="small" @click="addSchool2(item)">                    
                      <span style="margin: 0 4px;">院校详情</span>
                      <span v-if="item.isShowZyzDetail===false" class="el-icon-arrow-up"></span>
                      <span v-else class="el-icon-arrow-down"></span>
                    </el-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>

        </div>
          <div v-if="item.isShowZyzDetail" class="test11" style="width: 1040px;">
            <div v-for="(item2,index2) in allZyz" :key="index2">
              <div style="
                    height: 35px;
                    border-left: 5px solid #5287c6;
                    padding-left: 20px;
                    margin-bottom: 20px;
                    margin-top: 20px;">
                <h2>专业详情表</h2>
              </div>
              <div class="zyzDiv1"
              :style="index2>0?'':'margin-bottom:10px;'">
                <div class="zyz_title">专业组{{ item2.zyz }}</div>
                <div class="collect1" v-if="item2.sffc==0" @click="addZyzSchool(item,item2,1)">
                  加入收藏
                </div>
                <div class="collect1" v-else-if="item2.sffc==1" @click="addZyzSchool(item,item2,2)">
                  取消收藏
                </div>
              </div>
              <div>
                        <el-table :data="item2.zyTabList" border size="small" max-height="770"
                         :span-method="objectSpanMethod" :cell-style="objectCellMethod"
                        :header-cell-style="{'background-color':'#f5f7fa','border': '1px solid #09F',
                        'color': 'rgb(144, 147, 153)','text-align':'center','font-weight':'700','font-size':'14px'}">
                          <el-table-column label="专业名称" prop="zymc" :resizable="false" align="center"></el-table-column>
                          <el-table-column label="年份" prop="nd" :resizable="false" align="center">
                            <template slot-scope="scope">
                              <span v-if="scope.row.nd>0">{{ scope.row.nd }}</span>
                              <span v-if="scope.row.nd==0"> 平均 </span>
                            </template>
                          </el-table-column>
                          <el-table-column label="我的综合成绩" prop="equivalent"
                            :resizable="false" align="center"></el-table-column>
                          <el-table-column label="批次" prop="pc" :resizable="false" align="center">
                            <template slot-scope="scope">
                              <span v-if="scope.row.pc==0||scope.row.pc=='0'">本科提前批</span>
                              <span v-if="scope.row.pc==7||scope.row.pc=='7'">高职专科批</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="计划人数" :resizable="false" align="center">
                            <el-table-column label="历年" prop="snjhs" :resizable="false" align="center"> </el-table-column>
                            <el-table-column label="今年" prop="jnjhs" :resizable="false" align="center"></el-table-column>
                          </el-table-column>
                          <el-table-column label="专业" :resizable="false" align="center">
                            <template slot-scope="scope">
                              <el-button @click="addTianBaoSchool(scope.row,item,item2)" size="small"
                              type="primary" style="background-color:rgb(4, 121, 245);color:white;
                              border:rgb(4, 121, 245)">{{ scope.row.zyBtnTxt }}</el-button>
                            </template>
                          </el-table-column>
                          <el-table-column label="是否服从" :resizable="false" align="center">
                            <template >
                              <span>服从</span>
                            </template>
                          </el-table-column>
                        </el-table>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div v-else :class="{'school-out-div':artSchoolCondition.condition===2}">
      <div
        class="school-info"
        :class="{'school-info-other':artSchoolCondition.condition===2}"
        v-for="(item, index) in schoolData.data.records"
        :key="index"
      >
        <div class="info-logo">
          <router-link
            tag="a"
            target="_blank"
            :to="{
              path: '/main/schoolDetail/' + $route.name,
              query: { item: item.gb }
            }"
          >
            <img :src="item.logo" alt="院校logo" width="100%" height="100%" />
          </router-link>
        </div>
        <div class="info-introduce" :class="{'info-introduce-other':artSchoolCondition.condition===2}">
          <div class="school-name">
            <router-link
              tag="a"
              target="_blank"
              :to="{
                path: '/main/schoolDetail/' + $route.name,
                query: { item: item.gb }
              }"
            >
              <h3>{{ item.yxmc }}</h3>
            </router-link>
            <div class="school-lqgl" v-if="$route.path === '/schoolRecommend'">
              (录取率:{{ item.lqgl }}%)
            </div>
          </div>
          <div class="school-category">
            <div class="category-wrap category-type">
              <div class="category-item top-positon">
                院校性质:
                <span v-if="item.sfgb !== '0'">公办&nbsp;</span>
                <span v-else-if="item.sfmb !== '0'">民办&nbsp;</span>
                <span v-else-if="item.sfdl !== '0'">独立学院&nbsp;</span>
                <span v-else>暂无信息</span>
              </div>
              <div class="category-item top-positon">
                院校属性:
                <span v-if="item.sf985 !== '0'">985&nbsp;</span>
                <span v-if="item.sf211 !== '0'">211&nbsp;</span>
                <span v-else>普通高校</span>
              </div>
              <div class="category-item top-positon">
                所在省份:{{ item.yxdq }}
              </div>
              <div class="category-item">
                <!-- <button
                  type="button"
                  class="deleteSchool"
                  @click="deleteSchool(item)"
                  v-if="item.collect"
                >
                  取消收藏
                </button>
                <button
                  type="button"
                  class="addSchool"
                  @click="addSchool2(item)"
                  v-else
                >
                  加入收藏
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="chooseZyzDialog" :title="zyzTitle">
      <div>
        <el-select v-model="selectedZyz">
          <el-option v-for="(item,index) in allZyz" :key="index"
          :label="item.zyz" :value="item.zyz">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-button type="primary" size="small">确认</el-button>
        <el-button size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { addCollectSchool, removeCollectSchool } from "../../api/index";
import { mapState } from "vuex";
import { SCHOOL_FINDER_DATA } from "../../store/mutation-types";
export default {
  name: "SchoolsData",
  props: ["istype", "pageId"],
  data() {
    return {
      artSchoolCondition:{},
      module:{},
      tabFlag:false,
      chooseZyzDialog:false,
      zyzTitle:'',
      selectedZyz:'',
      allZyz:[],
      zyTabList:[]
    };
  },
  computed: {
    ...mapState(["schoolData", "userInfo"])
  },
  methods: {
    //添加关注院校
    async addSchool(item) {
      // const result = await addCollectSchool(this.userInfo.yhid, item.gb);
      const result = await this.module.addCollectSchool(this.userInfo.yhid, item.gb);
      if (result.data.code === 200) {
        this.$set(item, "collect", true);
      }else if(result.data.code===500){
            if(result.data.message){
                this.$message({message:result.data.message,type:'error'});
            }else if(result.data.msg){
              this.$message({message:result.data.message,type:'error'});
            }
      }else if(result.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(result.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(result.status===409||result.status===410||result.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }
    },
    // 打开专业组详情内容
    async addSchool2(item){
      console.log(item);
      this.$set(item,"isCanDisabled",true);
      const res=await this.$http.getHttp("/getZyzByGb?gbdm="+item.gb+"&&pc="+item.pc
      +"&&zylb="+(this.userInfo.zylb));
      console.log(res);
      if(res.data.code==200){
        const data=[...res.data.data];
        for(let i=0;i<data.length;i++){
          if(data[i].zyz){
            data[i].zyTabList=[];
          }
        }
        this.allZyz=data;
        // this.$set(item,"allZyz",data);
        // const schoolData22=[...this.schoolData.data.records];
        // for(let i=0;i<schoolData22.length;i++){
        //   if(schoolData22[i].yxmc==item.yxmc){
        //     schoolData22[i].allZyz=data;
        //     break;
        //   }
        // }
        // this.$store.commit(SCHOOL_FINDER_DATA,{schoolData:{data:{records:schoolData22}}});
      }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }else if(res.data.msg){
              this.$message({message:res.data.msg,type:'error'});
            }
      }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }
      const zyzs=this.allZyz;
      for(let a=0;a<zyzs.length;a++){
        if(zyzs[a].zyz){
          const res2=await this.$http.getHttp("/querySchoolDetailed/"+item.gb
          +'/'+zyzs[a].zyz+'/'+item.pc);
          if(res2.data.code==200){
                    this.detail11 = res2.data.data;
                    this.lqsj11 = res2.data.data.lqsj;
                    this.tdxList11 = res2.data.data.tdx;
                    this.yxZyzPlan11 = res2.data.data.yxZyzPlan;
                    let ndList = res2.data.data.list; 
                    let zyjhs = res2.data.data.listPlan;
                    let tdxList=res2.data.data.tdx;
                    let zyList=res2.data.data.zyList;
                    let sczyList=[...new Set([...res2.data.data.sczyList])];
                    let yxZyzPlan=res2.data.data.yxZyzPlan;
                    let arrNd = [];
                    let arrzyjhs = [];
                    let totalZyData=[];
                    let maxZyDataMaxNd=0;
                    for(let i=0;i<zyjhs.length;i++){
                      if(zyjhs[i]&&zyjhs[i].zymc&&zyjhs[i].zylb==this.userInfo.zylb){
                        const obj={};
                        obj.zymc=zyjhs[i].zymc;
                        const zymcFlagObj=totalZyData.find(item=>{
                          return item&&item.zymc&&item.zymc==zyjhs[i].zymc;
                        });
                        if(!zymcFlagObj){
                          totalZyData.push(obj);
                        }
                        if(zyjhs[i].nd>maxZyDataMaxNd){
                          maxZyDataMaxNd=zyjhs[i].nd;
                        }
                      }
                    }
                    console.log(totalZyData);
                    const arr2=[];
                    for(let i=0;i<totalZyData.length;i++){
                      if(totalZyData[i].zymc){
                        const obj3={...totalZyData[i]};
                        arr2.push(obj3);
                      }
                    }
                    const arr3=[];
                    for(let i=0;i<totalZyData.length;i++){
                      if(totalZyData[i].zymc){
                        const obj4={...totalZyData[i]};
                        arr3.push(obj4);
                      }
                    }
                    const arr4=[];
                    for(let i=0;i<totalZyData.length;i++){
                      if(totalZyData[i].zymc){
                        const obj5={...totalZyData[i]};
                        arr4.push(obj5);
                      }
                    }
                    // 33 73 49
                    totalZyData=[...totalZyData,...arr2,...arr3,...arr4];
                    let ndCountArr=[];
                    for(let i=0;i<totalZyData.length;i++){
                      if(totalZyData[i]&&totalZyData[i].zymc){
                        const ndCountFlagObj=ndCountArr.find(item=>{
                          return item&&item.zymc&&item.zymc==totalZyData[i].zymc;
                        });
                        if(!ndCountFlagObj){
                          const obj1={};
                          obj1.zymc=totalZyData[i].zymc;
                          obj1.count=1;
                          totalZyData[i].nd=maxZyDataMaxNd-obj1.count;
                          ndCountArr.push(obj1);
                        }else if(ndCountFlagObj.count<=2){
                          ndCountFlagObj.count++;
                          totalZyData[i].nd=maxZyDataMaxNd-ndCountFlagObj.count;
                        }else{
                          totalZyData[i].nd=0;
                        }
                      }
                    }
                    for(let i=0;i<totalZyData.length;i++){
                      if(totalZyData[i]&&totalZyData[i].zymc){
                        totalZyData[i].equivalent=tdxList[0].equivalent;
                        // totalZyData[i].pc=tdxList[0].pc;
                        totalZyData[i].pc=yxZyzPlan[0].pc;
                        const zyObj1=zyjhs.find(item=>{
                          return item&&item.zymc==totalZyData[i].zymc&&item.nd==maxZyDataMaxNd
                          &&item.zylb==this.userInfo.zylb;
                        });
                        const zyObj2=zyjhs.find(item=>{
                          return item&&item.zymc==totalZyData[i].zymc&&item.nd==totalZyData[i].nd
                          &&item.zylb==this.userInfo.zylb;
                        });
                        console.log(zyObj1,zyObj2);
                        console.log(totalZyData[i]);
                        totalZyData[i].jnjhs=zyObj1?zyObj1.jhs:null;
                        totalZyData[i].snjhs=zyObj2?zyObj2.jhs:null;
                      }
                    }
                    // 0 4 8 12 1->4 2->8 3->12
                    let totalZyData2=[];
                    for(let i=0;i<ndCountArr.length;i++){
                      if(ndCountArr[i]&&ndCountArr[i].zymc){
                        if(i==0){
                          ndCountArr[i].minIndex=0;
                        }else if(i>0){
                          ndCountArr[i].minIndex=i*4;
                        }
                      }
                    }
                    for(let i=0;i<ndCountArr.length;i++){
                      if(ndCountArr[i]&&ndCountArr[i].zymc){
                        const obj11=totalZyData.find(item=>{
                          return item&&item.zymc&&item.zymc==ndCountArr[i].zymc&&item.nd==maxZyDataMaxNd-1;
                        });
                        const obj12=totalZyData.find(item=>{
                          return item&&item.zymc&&item.zymc==ndCountArr[i].zymc&&item.nd==maxZyDataMaxNd-2;
                        });
                        const obj13=totalZyData.find(item=>{
                          return item&&item.zymc&&item.zymc==ndCountArr[i].zymc&&item.nd==maxZyDataMaxNd-3;
                        });
                        const obj14=totalZyData.find(item=>{
                          return item&&item.zymc&&item.zymc==ndCountArr[i].zymc&&item.nd==0;
                        });
                        totalZyData2[ndCountArr[i].minIndex]=obj11;
                        totalZyData2[ndCountArr[i].minIndex+1]=obj12;
                        totalZyData2[ndCountArr[i].minIndex+2]=obj13;
                        totalZyData2[ndCountArr[i].minIndex+3]=obj14;
                      }
                    }
                    // 3->0 8->7
                    for(let i=0;i<totalZyData2.length;i++){
                      if(totalZyData2[i]&&totalZyData2[i].zymc){
                        totalZyData2[i].yxmc=res.data.data.yxmc||'';
                        totalZyData2[i].gb=res.data.data.gb||item.gb||item.gbdm||'010';
                        totalZyData2[i].zyz=yxZyzPlan[0].zyz||'020';
                        // totalZyData2[i].pc=tdxList[0].pc<0?'030':tdxList[0].pc;
                        totalZyData2[i].pc=yxZyzPlan[0].pc<0?'030':yxZyzPlan[0].pc;
                        totalZyData2[i].zyBtnTxt='填报';
                        totalZyData2[i].collect=zyzs[a].sffc==1;
                      }
                    }
                    let collectZys=[];
                    for(let i=0;i<totalZyData2.length;i++){
                      for(let j=0;j<zyList.length;j++){
                        if(totalZyData2[i].zymc==zyList[j].zymc){
                          totalZyData2[i].zydh=zyList[j].zydh;
                          totalZyData2[i].sfRecruitStudents=true;
                        }else if(totalZyData2[i].zymc!=zyList[j].zymc&&j==zyList.length-1
                        &&!(totalZyData2[i].sfRecruitStudents)){
                          totalZyData2[i]=null;
                        }
                      }
                    }
                    totalZyData2=totalZyData2.filter(item=>{
                      return item!=null;
                    });
                    for(let i=0;i<totalZyData2.length;i++){
                      for(let j=0;j<collectZys.length;j++){
                        if(totalZyData2[i]&&totalZyData2[i].zymc
                        &&totalZyData2[i].zymc==collectZys[j].zymc){
                          totalZyData2[i].zyBtnTxt='专业'+collectZys[j].zyXh;
                        }
                      }
                    }
                    for(let i=0;i<sczyList.length;i++){
                      for(let j=0;j<totalZyData2.length;j++){
                        if(sczyList[i]==totalZyData2[j].zydh){
                          totalZyData2[j].zyBtnTxt='专业'+(i+1);
                        }
                      }
                    }
                    zyzs[a].zyTabList=totalZyData2;
                    ndList.map((item,i)=>{ arrNd.push(item.nd); });
                    zyjhs.map((item,i)=>{
                        arrzyjhs.push(item.nd);
                    });
                    this.jhndList = Array.from(new Set(arrzyjhs))
                    let MaxNdLq = Math.max(...arrNd);
                    if(MaxNdLq === -Infinity) {
                       this.MaxValueLq = '暂无数据'
                    }else {
                        this.MaxValueLq = MaxNdLq
                    }
                    this.lqDetail = ndList.filter((o)=>{
                        return o.nd ==  this.MaxValueLq
                    })
                    let MaxValueJhOne = Math.max(...arrzyjhs);
                    if(MaxValueJhOne === -Infinity) {
                        this.MaxValueJh = '暂无数据'
                    }else {
                        this.MaxValueJh = MaxValueJhOne
                    }    
                    this.lqjsDetali = zyjhs.filter((o)=>{
                        return o.nd ==  Math.max(...arrzyjhs);
                    });           
            }
        }
      }
      this.$set(item,"isCanDisabled",false);
      let dqIndex=-1;
      const schoolData=[...this.schoolData.data.records];
      for(let i=0;i<schoolData.length;i++){
        if(schoolData[i].yxmc==item.yxmc&&schoolData[i].pc==item.pc){
          dqIndex=i;
          break;
        }
      }
      if(!schoolData[dqIndex].isShowZyzDetail){
        for(let i=0;i<schoolData.length;i++){
          if(schoolData[i].yxmc){
            schoolData[i].isShowZyzDetail=false;
          }
        }
        schoolData[dqIndex].isShowZyzDetail=true;
      }else{
        schoolData[dqIndex].isShowZyzDetail=false;
      }
      const obj={...this.schoolData};
      obj.records=schoolData;
      this.$store.commit(SCHOOL_FINDER_DATA,{schoolData:{...obj}});
      this.$forceUpdate();
      
    },
    // 收藏院校专业组
    async addZyzSchool(item,item2,type=1){
      if(type==1){
        const obj={};
        obj.collegeid=item.gb||item.gbdm||item2.gb||item2.gbdm;
        obj.lb=this.userInfo.zylb;
        obj.pc=item.pc>=0?item.pc:item2.pc;
        obj.uid=this.userInfo.yhid;
        obj.zyz=item.zyz||item2.zyz;
        const res=await this.$http.postHttp("/addUserCollectionYxZyz",obj);
        console.log(res);
        if(res.data.code==200){
          const allZyz=[...this.allZyz];
          let index=-1;
          for(let i=0;i<allZyz.length;i++){
            if(allZyz[i].zyz==item.zyz||allZyz[i].zyz==item2.zyz){
              // allZyz[i].sffc=1;
              index=i;
              break;
            }
          }
          console.log(index);
          if(index>=0){
            this.$set(this.allZyz[index],"sffc",1);
          }
          this.$message({
            message:'收藏成功',
            type:'success',
            showClose:true
          });
          // this.allZyz=allZyz;
          // this.$forceUpdate();
        }else if(res.data.code===500){
              if(res.data.message){
                  this.$message({message:res.data.message,type:'error'});
              }else if(res.data.msg){
                this.$message({message:res.data.msg,type:'error'});
              }
        }else if(res.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.status===409||res.status===410||res.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }
      }else{
        const res=await this.$http.deleteHttp("/deleteUserCollectionYxZyz/"
        +this.userInfo.yhid+'/'+(item.gb||item.gbdm||item2.gb||item2.gbdm)
        +'/'+(item.zyz||item2.zyz)+'/'+(item.pc>=0?item.pc:item2.pc));
        if(res.data.code==200){
          const allZyz=[...this.allZyz];
          let index=-1;
          for(let i=0;i<allZyz.length;i++){
            if(allZyz[i].zyz==item.zyz||allZyz[i].zyz==item2.zyz){
              // allZyz[i].sffc=0;
              index=i;
              break;
            }
          }
          if(index>=0){
            this.$set(this.allZyz[index],"sffc",0);
          }
          const zyTabList=[...item2.zyTabList];
          for(let i=0;i<zyTabList.length;i++){
            if(zyTabList[i].zymc){
              this.$set(item2.zyTabList[i],"zyBtnTxt","填报");
              this.$set(item2.zyTabList[i],"collect",false);
            }
          }
          this.$message({
            message:'取消收藏成功',
            type:'success',
            showClose:true
          });
          // this.allZyz=allZyz;
          // this.$forceUpdate();
        }else if(res.data.code===500){
              if(res.data.message){
                  this.$message({message:res.data.message,type:'error'});
              }else if(res.data.msg){
                this.$message({message:res.data.msg,type:'error'});
              }
        }else if(res.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.status===409||res.status===410||res.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }
      }
    },
    async addTianBaoSchool(row,item,item2){
      const loading=this.$loading({
        fullScreen:true,
        target:document.getElementById("outZyTab"),
        text:'正在处理中'
      });
      const isSc=row.collect;
      const collegeid=row.gb;
      const pc=row.pc;
      const zydh=row.zydh;
      const zyz=row.zyz;
      const lb=this.userInfo.zylb;
      const uid=this.userInfo.yhid;
      const zyData=[...item2.zyTabList];
      let collectZys=[];
      const zyBtnTxt=row.zyBtnTxt;
      let zydhs=[];
      for(let i=0;i<zyData.length;i++){
        if(zyData[i].zymc&&zyData[i].zyBtnTxt
        &&zyData[i].zyBtnTxt.indexOf('专业')>=0){
          const collectObj=collectZys.find(item=>item.zydh==zyData[i].zydh);
          if(collectObj){
            continue;
          }
          const obj16={};
          obj16.zymc=zyData[i].zymc;
          obj16.zyXh=zyData[i].zyBtnTxt.split('专业')&&zyData[i].zyBtnTxt.split('专业').length?
          parseInt(zyData[i].zyBtnTxt.split('专业')[1]):'';
          obj16.zydh=zyData[i].zydh;
          collectZys.push(obj16);
        }
      }
      const obj={
        collegeid,
        lb,
        pc,
        uid,
        // zydh1:zydh,
        // zydh2:'',
        // zydh3:'',
        // zydh4:'',
        // zydh5:'',
        // zydh6:'',
        zyz
      };
      collectZys=collectZys.sort((a,b)=>{
        return a.zyXh-b.zyXh;
      });
      console.log(collectZys);
      console.log(row);
        let maxZyXh=0;
      if(collectZys.length){
        for(let i=0;i<collectZys.length;i++){
          if(collectZys[i]&&collectZys[i].zymc){
            obj['zydh'+(collectZys[i].zyXh)]=collectZys[i].zydh;
            if(collectZys[i].zyXh>maxZyXh){
              maxZyXh=collectZys[i].zyXh;
            }
          }
        }
        if(maxZyXh>5&&row.zyBtnTxt.indexOf('专业')==-1){
          this.$message({
            message:'一个院校专业组最多只能选择6个专业',
            type:'warning'
          });
          return;
        }
        if(maxZyXh>0){
          // 记录该专业代号是否已经保存的标志位
          let overEditZyFlag=false;
          for(let i=1;i<7;i++){
            if(obj['zydh'+i]&&obj['zydh'+i]==row.zydh){
              obj['zydh'+i]=null;
              overEditZyFlag=true;
              break;
            }
          }
          if(!overEditZyFlag){
            obj['zydh'+(parseInt(maxZyXh)+1)]=row.zydh;
          }
        }
      }else{
        obj['zydh1']=row.zydh;
        for(let i=0;i<zyData.length;i++){
          if(zyData[i].zydh==row.zydh){
            zyData[i].zyBtnTxt='专业1';
          }
        }
      }
        // 统计所有专业
        const zydhTotal1=[];
        // 统计所有专业位置
        const zydhPos1=[];
        // 新的专业情况
        let zydhTotal2=[];
        // 新的专业排序情况
        let zydhPos2=[];
      if(row.zyBtnTxt.indexOf('专业')>=0){
        for(let i=0;i<collectZys.length;i++){
          if(collectZys[i].zymc){
            if(zydhTotal1.indexOf(collectZys[i].zydh)==-1){
              const obj17={...collectZys[i]};
              zydhTotal1.push(obj17.zydh);
           }
          }
        }

        for(let i=0;i<zydhTotal1.length;i++){
          if(zydhTotal1[i]){
            zydhPos1.push(i+1);
          }
        }
        zydhTotal2=[...zydhTotal1]
        // zydhPos2=[...zydhPos1];
        for(let i=0;i<zydhTotal2.length;i++){
          if(zydhTotal2[i]==row.zydh){
            zydhTotal2[i]=null; 
            zydhPos2[i]=null;
          }    
        }
        zydhTotal2=zydhTotal2.filter(item=>item!=null);
        for(let i=0;i<zydhTotal2.length;i++){
          if(zydhTotal2[i]&&i<=5){
            zydhPos2.push(i+1);
          }
        }
        zydhPos2=zydhPos2.filter(item=>item!=null);
        if(zydhPos2.length){
          for(let i=1;i<7;i++){
            obj['zydh'+i]=null;
          }
        }
        console.log(zydhTotal1,zydhTotal2,zydhPos1,zydhPos2);
        if(zydhTotal2.length==zydhPos2.length){
          for(let i=0;i<zyData.length;i++){
            for(let j=0;j<zydhTotal2.length;j++){
              if(zyData[i].zydh==zydhTotal2[j]){
                if(zydhPos2[j]>=1&&zydhPos2[j]<=6){
                  zyData[i].zyBtnTxt='专业'+zydhPos2[j];
                  obj['zydh'+(zydhPos2[j])]=zydhTotal2[j];
                }
              }
            }
          }
        }
      }
      if(!row.collect){
          const res=await this.$http.postHttp("/addUserCollectionYxZyz",obj);
        if(res.data.code==200){
          if(res.data.msg){
            this.$message({
              message:res.data.msg,
              type:'success'
            });
          }else{
            this.$message({
              message:'操作成功',
              type:'success'
            });
          }
          const zyzs=[...this.allZyz];
          let index=-1;
          for(let i=0;i<zyzs.length;i++){
            if(zyzs[i].zyz==item2.zyz){
              index=i;
              break;
            }
          }
          
          if(index>=0){
            this.$set(this.allZyz[index],"sffc",1);
          }
        }else if(res.data.code==500){
          if(res.data.message){
            this.$message({
              type:"error",
              message:res.data.message
            });
          }else if(res.data.msg){
            this.$message({
              type:"error",
              message:res.data.msg
            });
          }
        }else if(res.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.status===409||res.status===410||res.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }

        
      }else{
        const res=await this.$http.postHttp("/updateYhgzYxZyz",obj);
        if(res.data.code==200){
          if(res.data.msg){
            this.$message({
              message:res.data.msg,
              type:'success'
            });
          }else{
            this.$message({
              message:'操作成功',
              type:'success'
            });
          }
          if(row.zyBtnTxt.indexOf('专业')==-1){
            for(let i=0;i<zyData.length;i++){
                if(zyData[i].zymc==row.zymc&&parseInt(maxZyXh)<=5
                &&row.zyBtnTxt.indexOf('专业')==-1){
                  zyData[i].zyBtnTxt='专业'+(parseInt(maxZyXh)+1);
                }
            }
          }else if(row.zyBtnTxt.indexOf('专业')>=0&&zydhPos2.length){
            for(let i=0;i<zyData.length;i++){
              if(zyData[i].zydh==row.zydh){
                zyData[i].zyBtnTxt='填报';
              }
            }
          }else if(row.zyBtnTxt.indexOf('专业')>=0&&zydhPos1.length==1){
            for(let i=0;i<zyData.length;i++){
              if(zyData[i].zydh==row.zydh){
                zyData[i].zyBtnTxt='填报';
              }
            }
          }
          this.zyTabList=zyData;
        }else if(res.data.code==500){
          if(res.data.message){
            this.$message({
              type:"error",
              message:res.data.message
            });
          }else if(res.data.msg){
            this.$message({
              type:"error",
              message:res.data.msg
            });
          }
        }else if(res.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.status===409||res.status===410||res.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        } 
      }

      if(!row.collect){
        const schoolData=[...this.schoolData.data.records];
        const yxmc=row.yxmc;
        for(let i=0;i<schoolData.length;i++){
          if(schoolData[i]&&schoolData[i].yxmc
          &&schoolData[i].yxmc==yxmc&&schoolData[i].zyz==zyz){
            schoolData[i].collect=!schoolData[i].collect;
            schoolData[i].isCollect=!schoolData[i].isCollect;
          }
        }
        const schoolObj={...this.schoolData};
        schoolObj.data.records=schoolData
        this.$store.commit(SCHOOL_FINDER_DATA,{schoolData:{...schoolObj}});
        for(let i=0;i<zyData.length;i++){
          if(zyData[i].zymc){
            zyData[i].collect=!zyData[i].collect;
          }
        }
      }
      this.$set(item,"collect",true);
      loading.close();
    },
    // 跨行
    objectSpanMethod({row, column, rowIndex, columnIndex }){
            if(columnIndex===0||columnIndex===2||columnIndex===3||
            columnIndex===5||columnIndex===6||columnIndex===7){
                if(rowIndex%4===0){
                    return{
                        rowspan:4,
                        colspan:1
                    };
                }else {
                    return {
                        rowspan:0,
                        colspan:0
                    };
                }
            }
    },
    objectCellMethod({row,column,rowIndex,columnIndex}){
      // 'color':'#ED4A09','font-weight':'bold'
            if(rowIndex%4===3&&columnIndex===7){
                return{'border':'1px solid #09F','text-align':'center',};
            }else{
                return{'border':'1px solid #09F','text-align':'center'};
            }
    },
    async getApiIndexMethod(){
      const flag=this.$apiFlag;
      if(flag===1||flag===3){
        this.module=await import("../../api/index");
      }else if(flag===2){
        this.module=await import("../../api/index22");
      }
    },
    //删除关注院校
    async deleteSchool(item) {
      const result = await this.module.removeCollectSchool({
        yhid: this.userInfo.yhid,
        collegeid: item.gb
      });
      if (result.data.code === 200) {
        this.$set(item, "collect", false);
      }else if(result.data.code===500){
            if(result.data.message){
                this.$message({message:result.data.message,type:'error'});
            }else if(result.data.msg){
              this.$message({message:result.data.msg,type:'error'});
            }
      }else if(result.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(result.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(result.status===409||result.status===410||result.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      } 
    }
  },
  async mounted(){
    this.artSchoolCondition=this.$parent.artSchoolCondition;
    console.log(this.tabFlag);
    await this.getApiIndexMethod();
  }
};
</script>

<style lang="stylus" scoped>
.school-data-wrap
    width 1100px
    margin 0 auto
    padding 0 30px 15px
    box-sizing border-box
    background-color #ffffff
    .school-info
        display flex
        padding 20px 0
        border-bottom 1px solid #E4E7ED
        flex-wrap wrap
        .info-logo
            width 100px
            height 100px
        .info-introduce
            width 940px
            padding-left 20px
            box-sizing border-box
            .school-name
                display flex
                align-items center
                font-size 20px
                color #303133
                .school-lqgl
                    margin-left 10px
                    font-size 14px
                    color #f66
            .school-category
                width 920px
                display flex
                font-size 14px
                .category-wrap
                    width 35%
                    color #666
                    .addSchool
                        width 100px
                        height 30px
                        font-size 14px
                        border 1px solid #f90
                        border-radius 5px
                        color #f90
                        background-color #fff
                        outline none
                        cursor pointer
                    .deleteSchool
                        width 100px
                        height 30px
                        font-size 14px
                        border 1px solid #2186de
                        border-radius 5px
                        color #2186de
                        background-color #fff
                        outline none
                        cursor pointer
                    .category-item
                        display inline-block
                        width 150px
                        margin-bottom 10px
                        overflow hidden
                        white-space nowrap
                        text-overflow ellipsis
                    .category-item:last-child
                        position relative
                        top 6px
                    .top-positon
                        margin-top 20px
                .category-type
                    width 100%
                    display flex
                    justify-content space-between
                    align-items center

                .info-data-wrap
                    width 65%
                    .info-data
                        width 100%
                        color #666
                        th
                            border 1px solid  #09F
                            padding 1px 0
                            text-align center
                            background-color #e4f5ff
                        td
                           padding 1px 5px
                           border 1px solid  #09F
                           text-align center
</style>
<style scoped>
.school-info-other{
  margin:15px;
}
.school-out-div{
  display: flex;
  flex-wrap: wrap;
}
.info-introduce-other{
  width:320px !important;
}
.school-data-wrap-other{
  width: 980px;
}
h1,h2,h3,h4,h5,h6{
    margin: 0 !important;
    font-weight: 700 !important;
}
.zyzDiv1{
      display: flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    padding: 5px;
    font-size: 18px;
    font-weight: 600;
    color: #fefefe;
    background: #26bee4;
}
.collect1{
      padding: 3px 10px;
    font-size: 14px;
    color: #fff;
    border: 1px solid #f17070;
    border-radius: 3px;
    background: #f17070;
    cursor: pointer;
}
</style>
